import React from "react";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/tabs";
import { Text } from "@chakra-ui/react";

interface Props {
  leftText?: string;
  rightText?: string;
  onChange?: (index: number) => void;
  index?: number;
  width?: string;
}

function ToggleTab({
  leftText,
  rightText,
  onChange,
  index,
  width,
}: Props = {}) {
  return (
    <Tabs variant="unstyled" onChange={onChange} index={index}>
      <TabList
        height={"28px"}
        background={"#F7F9FA"}
        borderRadius={"4px"}
        border={"1px solid #D4D4D1"}
        color={"#6F6F6C"}
        fontSize={"14px"}
        fontWeight={400}
        whiteSpace={"nowrap"}
        overflow={"hidden"}
      >
        <Tab
          _selected={{ color: "#444444", bg: "#FFFFFF", fontWeight: 600 }}
          width={width ?? "80px"}
          borderRadius={"2px"}
        >
          <Text textStyle={"body-md-semibold"}>{leftText}</Text>
        </Tab>
        <Tab
          _selected={{ color: "#444444", bg: "#FFFFFF", fontWeight: 600 }}
          width={width ?? "80px"}
          borderRadius={"2px"}
        >
          <Text textStyle={"body-md-semibold"}>{rightText}</Text>
        </Tab>
      </TabList>
    </Tabs>
  );
}

export default ToggleTab;
